import React, { useEffect, useState } from "react";
import FrameTopNav from "./FrameTopNav";
import FrameLeftNav from "./FrameLeftNav";
import FramePageContainer from "./FramePageContainer";
import FramePageContentWrapper from "./FramePageContentWrapper";
import ErrorBoundary from "./ErrorBoundary";
import getCurrentDate from "../Common/getCurrentDate";
import { useDispatch } from "react-redux";
import { setCurrentPageNotification } from "../redux/notificationSlice";
import { getNotificationForError } from "../components/Alert";
import { get } from "../Common/api";

export default function Frame(props) {
  let { insideRouter } = props;
  const dispatch = useDispatch();
  const[version, setVersion] = useState("1.0.0.0");

  useEffect(async ()=> {
    try{
      //loads the version from admin API.
      const response = await get(`/`);
      setVersion(response.version);
    }
    catch(error){
      dispatch(setCurrentPageNotification(getNotificationForError(error)));
    }
  }, [version]);

  return (
    <ErrorBoundary>
      {/* BEGIN HEAD */}
      <FrameTopNav />
      <FramePageContainer>
        <FrameLeftNav insideRouter={insideRouter} initLayout={true} />
        <FramePageContentWrapper>
          {/* BEGIN CONTENT */}
          {props.children}
          {/* END CONTENT */}
        </FramePageContentWrapper>
      </FramePageContainer>
      <div className="footer">
        <div className="footer-inner">Build {version}</div>
        <div className="copy-right-footer">
          {getCurrentDate().getFullYear()} © Food Service Solutions, Inc. All
          rights reserved.
        </div>
      </div>
      <div
        className="modal fade"
        id="About"
        tabIndex={-1}
        role="basic"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg"
          style={{ width: "415px", marginTop: "193px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              />
              <h4 className="modal-title">About MySchoolAccount</h4>
            </div>
            <div className="modal-body">
              <div style={{ textAlign: "center" }}>
                <div className="aboutme">
                  <svg>
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 600 205.75"
                    >
                      <defs>
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              ".cls-1{fill:#312852;}.cls-2{fill:#359a5b;}",
                          }}
                        />
                      </defs>
                      <path
                        className="cls-1"
                        d="M176.51,9.19a6.36,6.36,0,0,0-2.75-2.61,6.14,6.14,0,0,0-2.45-.64,6.24,6.24,0,0,0-4.11,1.33,6,6,0,0,0-1.66,1.92l-52.73,94.5h19.86a7,7,0,0,0,6-3.44L146,87h50.13l7.3,13.22a7,7,0,0,0,6,3.44h19.86ZM155.14,70.62,171,42.16h0l15.89,28.46Z"
                      />
                      <path
                        className="cls-1"
                        d="M71.22,67.46h0l-8-14.26L38.85,9.36a6.94,6.94,0,0,0-6-3.43H13s52.88,94.73,53,94.85a6.3,6.3,0,0,0,5.25,2.91h0a6.3,6.3,0,0,0,5.25-2.91c.08-.12.16-.23.23-.35s3-5.18,6.4-11.26Z"
                      />
                      <path
                        className="cls-1"
                        d="M536.18,3.57h0c-29.94,0-51.73,21.48-51.82,51.1-.09,30,21.17,51,51.7,51.09h.29c30.53-.11,51.79-21.12,51.7-51.09C587.91,25.05,566.12,3.57,536.18,3.57Zm0,82.22c-17.42-.12-30.15-13-30.33-30.72a31.27,31.27,0,0,1,8.6-22.51A30.18,30.18,0,0,1,536,23.83h.33a30.18,30.18,0,0,1,21.57,8.73,31.27,31.27,0,0,1,8.6,22.51C566.31,72.81,553.58,85.67,536.15,85.79Z"
                      />
                      <path
                        className="cls-1"
                        d="M336.59,5.92a6.5,6.5,0,0,0-6.5,6.5V63.59S264.18,9.42,262.78,8.3a11.55,11.55,0,0,0-3.09-2.05,5.59,5.59,0,0,0-7.06,3.05,6.87,6.87,0,0,0-.34,2.82v91.53h15.29a6.5,6.5,0,0,0,6.5-6.5V43.06l72.39,60.59h5.22V5.92Z"
                      />
                      <path
                        className="cls-1"
                        d="M455.59,77.23l-.52.54C455,77.85,447,86,432.79,86c-17.94,0-31-13.15-31-31.29s13-31.12,31-31.12c12.35,0,22.24,8,22.33,8.07l.52.42L467.46,16.1l-.34-.39c-.44-.49-11.1-12.14-34.65-12.14-15.32,0-28.46,5.18-38,15-9.06,9.29-14,22.12-14,36.13s5,26.85,14,36.14c9.55,9.78,22.69,15,38,15,23.39,0,34.54-12,34.65-12.14l.34-.38Z"
                      />
                      <path
                        className="cls-2"
                        d="M75.91,59.21l3.27-6,24.4-43.84a7,7,0,0,1,6-3.43h19.86S106.6,46.85,91,74.83c-1.36,2.45-1.79,3.37-3,5.59Z"
                      />
                      <path
                        className="cls-1"
                        d="M210.84,161.78v13.81h21.92v7.13H210.84V200.1h-8.43V154.71h33.14v7.07Z"
                      />
                      <path
                        className="cls-1"
                        d="M241.57,177.41c0-13.43,10.38-23.35,24.45-23.35s24.45,9.86,24.45,23.35S280.09,200.75,266,200.75,241.57,190.83,241.57,177.41Zm40.4,0a16,16,0,1,0-16,16A15.47,15.47,0,0,0,282,177.41Z"
                      />
                      <path
                        className="cls-1"
                        d="M297.78,177.41c0-13.43,10.38-23.35,24.45-23.35s24.44,9.86,24.44,23.35-10.37,23.34-24.44,23.34S297.78,190.83,297.78,177.41Zm40.4,0a15.95,15.95,0,1,0-15.95,16A15.47,15.47,0,0,0,338.18,177.41Z"
                      />
                      <path
                        className="cls-1"
                        d="M357.23,154.71h19.84c14.72,0,24.77,9.08,24.77,22.7s-10,22.69-24.77,22.69H357.23ZM376.69,193c10.11,0,16.66-6.16,16.66-15.56s-6.55-15.57-16.66-15.57h-11V193Z"
                      />
                    </svg>
                  </svg>
                </div>
                <div>&nbsp;</div>
                <div
                  className="well"
                  style={{
                    marginLeft: "-15px",
                    marginRight: "-15px",
                    marginBottom: "0px",
                  }}
                >
                  <div>
                    Product Version <strong>17.00.11.23321</strong>
                  </div>
                  <div>&nbsp;</div>
                  <div>
                    Visit{" "}
                    <a href="https://www.myschoolaccount.com/" target="_blank">
                      https://www.myschoolaccount.com
                    </a>{" "}
                    for more information.
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ borderTop: "0px" }}>
              <hr />
              <a
                href="#"
                className="btn btn-primary btn-sm"
                data-dismiss="modal"
              >
                Close
              </a>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/*[if lt IE 9]>
      <![endif]*/}
    </ErrorBoundary>
  );
}
